export const BoardKey = 'readBoard';
export const ReadDetailProject = 'readDetailProject';
export const ReadDetailProjectMember = 'readDetailProjectMember';
export const ProjectLiked = 'projectLiked';
export const Notification = 'notification';
export const Comments = 'comment';
export const ReComment = 'reComment';
